import React, { useContext, useEffect, useState } from 'react';
import { Dropdown } from '@/ui/molecules/InputSection/DropdownComponents/StyledDropdown';
import { LanguageResponse } from '@/api/tax-guide';
import { TaxGuideContext } from '@/state/TaxGuideProvider';

type LanguageDropdownProps = {
  languages: LanguageResponse[];
  enabled: boolean;
};

export const LanguageDropdown: React.FC<LanguageDropdownProps> = ({
  languages,
  enabled,
}) => {
  if (!enabled) return null;
  const languageResponse = languages;
  const [languageType, setLanguage] = useState<LanguageResponse | undefined>(
    languageResponse?.[0],
  );

  const { updateRequest } = useContext(TaxGuideContext);
  useEffect(() => {
    updateRequest({
      language: languageType?.id ?? '',
    });
  }, [languageType]);

  return (
    <Dropdown
      label="Language"
      id={languageType?.id ?? ''}
      options={languageResponse.map(lang => ({
        id: lang.id,
        name: lang.value,
      }))}
      handleChange={selectedLang => {
        const setSelectedLang = languageResponse?.filter(
          lang => lang.id === selectedLang,
        )?.[0];
        setLanguage(setSelectedLang);
      }}
    />
  );
};
